import { redirect } from "react-router-dom";

import { store } from "../../../../..";
import { leagueManagementActions } from "../../../../../features/leaguemgmt/leagueManagementSlice";
import { getTeamRatings } from "../../../../../lib/api";
import { AUTH_LEVELS } from "../../../../../lib/globals";

export const loader = async ({ params }: any) => {
    const teamId = parseInt(params.teamId);
    const state = store.getState();

    const { user } = state.auth;
    const { years } = state.leaguemanagement;

    if (!user || !AUTH_LEVELS.leaguemanagement.includes(user?.userLevel)) {
        return redirect(`/coachs-clubhouse/team/${teamId}`);
    }

    const promises = [];

    !years && promises.push(store.dispatch(leagueManagementActions.getYears()));

    const [{ ratings }] = await Promise.all([
        getTeamRatings(teamId),
        ...promises,
    ]);

    return {
        teamId,
        ratings,
    };
};

export default loader;
